
<div class="carousel-wrapper">
  <!-- Background Carousel -->
  <owl-carousel-o [options]="backgroundCarouselOptions" class="background-carousel">
    <ng-template carouselSlide *ngFor="let bg of backgroundImages">
      <div class="bg-slide" [ngStyle]="{ 'background-image': 'url(' + bg + ')' }"></div>
    </ng-template>
  </owl-carousel-o>

  <!-- Overlay Carousel -->
  <div class="overlay-content">
    <owl-carousel-o [options]="contentCarouselOptions">
      <ng-template carouselSlide *ngFor="let content of contentSlides">
        <div class="content-box">
          <h1 style="color: wheat;">{{ content.title }}</h1>
          <p style="color: white;">{{ content.description }}</p>
          <a *ngIf="content.title.includes('Admission')" routerLink="/enquiry" class="btn-apply">Apply Now</a>
        </div>
      </ng-template>
    </owl-carousel-o>
  </div>
</div>

